import axios from "axios";
import {appUrls, endPoints } from "Constants/urls";

export const fetchDowntimeList = (params) => {
  // const url = 'https://demo7403748.mockable.io/downtime';
  const url = `${appUrls.ORCHESTRATION_LAYER}${endPoints.DOWNTIME_LIST}`
  return axios({
    method: "GET",
    url,
    params,
  });
};
export const fetchDowntimeFilter = (params) => {
  // const url = 'https://demo7403748.mockable.io/downtime-filter-list';
  const url = `${appUrls.ORCHESTRATION_LAYER}${endPoints.DOWNTIME_FILTER}`
  return axios({
    method: "GET",
    url,
    params,
  });
};